module.exports = __webpack_public_path__ + "static/media/id@2x.f74da463.png";